import { Button, Dropdown, Menu, Grid } from "antd";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, SwitchButton } from "components/base";
import { useHistory, useLocation } from "react-router-dom";
import { setModalName, setVehiclesSearch } from "store/actions";
import {
    actionMenu,
    exportIcon,
    plusIcon,
    searchIcon,
    zonesSmallIcon,
    addAssigneeIcon,
    archiveIcon,
} from "svgs";
import { ROUTES } from "utils/constants";
import { AppState } from "store";
import "styles/components/tab-headers/battery-model-header.scss";
const { useBreakpoint } = Grid;

export default function BatteryModelHeader() {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const screens = useBreakpoint();

    const selectedView = location.pathname.split("/")[2];
    const { showbulkActionsVehicles } = useSelector<AppState, AppState["vehicles"]>(
        (state) => state.vehicles
    );

    const onBulkVehiclesFirmwareUpdate = useCallback(() => {
        dispatch(setModalName("bulk_update_vehicle_firmware"));
    }, [dispatch]);

    const onAddBatteryModel = useCallback(() => {
        dispatch(setModalName("add_battery_model"));
    }, [dispatch]);

    const onSwitchView = useCallback(
        (event) => {
            const { value } = event.target;
            if (value == "Batteries")
                history.push(`${ROUTES.battery}/table`);
        },
        [history]
    );

    const onImportCsv = useCallback(() => {
        dispatch(setModalName("import_csv"));
    }, [dispatch]);

    const onChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(setVehiclesSearch(event.target.value));
        },
        [dispatch]
    );

    const menu = (
        <Menu className="vehicle-drop-menu">
            <Menu.Item key="0" onClick={onImportCsv}>
                <span>Import</span>
            </Menu.Item>
            <Menu.Item key="1" disabled>
                <span>Export</span>
            </Menu.Item>
        </Menu>
    );

    // Determine device type
    const isMobile = !screens.sm;
    const isTablet = screens.sm && !screens.lg;

    return (
        <div className={`common-header battery-model-header ${isMobile ? 'mobile' : ''} ${isTablet ? 'tablet' : ''}`}>
            {/* Search Input - Hidden by default, uncomment if needed */}
            {/*
            <Input
                customClasses="--standard header-search"
                placeholder="Search Battery models..."
                prefix={searchIcon}
                onChange={onChange}
            />
            */}

            {/* Bulk Actions */}
            {showbulkActionsVehicles && (
                <article className="bulk-actions">
                    <Button 
                        disabled 
                        danger 
                        icon={archiveIcon}
                        size={isMobile ? "small" : "middle"}
                    >
                        {!isMobile && "Archive"}
                    </Button>
                </article>
            )}

            {/* Actions Container */}
            <div className="actions-container">
                <SwitchButton
                    label=""
                    options={["Batteries", "Battery Models"]}
                    defaultOption={"Battery Models"}
                    onChange={onSwitchView}
                    type="secondary"
                />

                <div className="vertical-separator" />

                {/* Add Button - Full on desktop, icon only on mobile */}
                {isMobile ? (
                    <Button
                        type="primary"
                        icon={<span className="custom-icon">{plusIcon}</span>}
                        onClick={onAddBatteryModel}
                        size="middle"
                        className="add-btn-mobile"
                        >
                        <h1 style={{ fontSize: "16px", margin: 0 , color: "#fff",}}>Add Model</h1>
                        </Button>
                
                ) : (
                    <Button
                        type="primary"
                        icon={<span className="custom-icon">{plusIcon}</span>}
                        onClick={onAddBatteryModel}
                        size={isTablet ? "middle" : "large"}
                    >
                        {isTablet ? "Add" : "Add Battery Model"}
                    </Button>
                )}
            </div>
            {isMobile && ( <h1 style={{ paddingTop: "6px", alignItems: "left" }}>Battery Models</h1>)}
        </div>
    );
}